var React = require('react');

function NpLongHorizontal (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M264.543 38.0006C264.544 58.987 247.531 76.0006 226.545 76.0013L-3.99783 76.0095C-24.9842 76.0102 -41.9976 58.9981 -41.9985 38.0117C-41.9993 17.0253 -24.9871 0.0117259 -4.0006 0.0109889L226.542 0.00285547C247.529 0.00211078 264.542 17.0142 264.543 38.0006Z"}));
}

NpLongHorizontal.defaultProps = {"width":"265","height":"77","viewBox":"0 0 265 77"};

module.exports = NpLongHorizontal;

NpLongHorizontal.default = NpLongHorizontal;
